<template>
  <div class="error">Strona nie istnieje: błąd 404</div>
</template>

<script>
export default {};
</script>

<style>
.error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
}
</style>